"use client";

import { handleUnauthorized } from "../services/handleErrorServices";
// Import the service's type directly
import { migrateGenerate } from "../services/migration/migrateGenerate";
import { MigrationFormData } from "../types/migrations";

interface UseMigrationProcessResult {
  generateMigrate: (
    migrationId: string,
    appis: [] | any,
    formData: MigrationFormData,
    logout: () => void
  ) => Promise<boolean>;
}

/**
 * Hook generate migrate
 */
export function useMigrateGenerate(): UseMigrationProcessResult {
  const generateMigrate = async (migrationId: string, appis: [], formData: MigrationFormData, logout: any) => {
    try {
      const response = await migrateGenerate(migrationId, appis, formData);
      if (response.content && response.status === 200) {
        return response;
      } else {
        handleUnauthorized(response, logout);
        return false;
      }
    } catch (error) {
      console.log(error);
    }
  };

  return {
    generateMigrate,
  };
}
